// src/main.tsx
// SPA entry point — mounts the React app with RouterProvider
// into the #root element. Imports global styles, then the showcase pointer effects, the
// work panels' type scale and the space motifs (orbit and star dust).

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { router } from './router'
import { Providers } from './providers'
import '@/src/globals.css'
import '@/src/pointer-effects.css'
import '@/src/work-panels.css'
import '@/src/space-motifs.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
